import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfirmProvider } from "@opero/ui";
import { initAnalytics } from "@opero/shared/analytics";
import "./index.css";
import App from "./App";

initAnalytics({
  appName: "opero-web",
  posthog: {
    key: import.meta.env.VITE_POSTHOG_KEY,
    host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
    sessionRecording: false,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
    tracesSampleRate: 0.2,
  },
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <ConfirmProvider>
      <App />
    </ConfirmProvider>
  </BrowserRouter>,
);
